import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'

const SecurityWrap = styled.div`
  display: block;

  > p {
    margin: 16px 0;
    color: ${COLOR.red};
    font-size: 14px;
    line-height: 20px;
    font-family: NotoSansRegular, sans-serif;
  }
`
const SecurityContent = styled.div`
  height: 242px;
  border-radius: 10px;
  background: ${COLOR.gray10};
  margin-bottom: 16px;
  padding: 16px;

  > section {
    width: 100%;
    height: 96px;
    background: ${COLOR.white};

    > img {
      display: flex;
      width: 240px;
      height: 96px;
      margin: 0 auto;
      padding: 10px 0 6px 0;
    }
  }

  > img {
    cursor: pointer;
    margin: 16px auto;
    display: flex;
    width: 91px;
    height: 26px;
  }
`

export { SecurityContent, SecurityWrap }
